<template>
    <v-app-bar app color=primary dense dark>
        <v-app-bar-nav-icon @click.stop="toggleSiderLeftVisibility"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click.stop="toggleSiderRightVisibility"></v-app-bar-nav-icon>
    </v-app-bar>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "Header",

        computed: mapState([
            "pageTitle"
        ]),

        methods: {
            ...mapMutations([
                "toggleSiderLeftVisibility",
                "toggleSiderRightVisibility"
            ])
        }
    };
</script>

<style scoped>

</style>
